import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-G24YS9C6LS';

export const initGA = () => {
  ReactGA.initialize([
    {
      trackingId: GA_MEASUREMENT_ID,
      gaOptions: {
        debug_mode: true, // ✅ This enables DebugView tracking
      },
    },
  ]);
};

export const logEvent = (eventName, params = {}) => {
  ReactGA.event(eventName, params);
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};
